<template>
  <b-autocomplete
    v-model="title"
    :data="data"
    icon="magnify"
    placeholder="Select issue"
    field="title"
    :loading="isFetching"
    @input="getAsyncData"
    @select="option => { selected = option }"
    open-on-focus
    expanded
  >
    <template slot-scope="{ option: issue }">
      <div class="media">
        <div class="media-content">
          <strong>{{ issue.id }}</strong>
          <div class="has-text-grey">{{ issue.title }} ({{ issue.magazine.name }})</div>
        </div>
      </div>
    </template>
  </b-autocomplete>
</template>

<script>
import debounce from "lodash/debounce";

export default {
  props: {
    type: String,

    url: {
      type: String,
      default: "/admin/api/magazine/issues"
    }
  },

  data() {
    return {
      data: [],
      title: "",
      selected: null,
      isFetching: false
    };
  },

  created() {
    this.getAsyncData();
  },

  watch: {
    selected(issue) {
      this.$emit("input", issue ? issue.id : null);

      this.$emit("change", issue);
    }
  },

  methods: {
    clear() {
      this.title = "";
      this.selected = null;
    },

    getAsyncData: debounce(function() {
      this.data = [];
      this.isFetching = true;
      this.$http
        .get(this.url, {
          params: {
            search: this.title,
            "filter[type]": this.type
          }
        })
        .then(({ data }) => {
          data.data.forEach(item => this.data.push(item));
          this.isFetching = false;
        })
        .catch(error => {
          this.isFetching = false;
          throw error;
        });
    }, 300)
  }
};
</script>
